<template>
    <li class="driver-dashboard-project-item">
        <!-- <span v-if="isSyncing"
            title="Sync in progress..."
            class="badge badge-info progress-bar-striped progress-bar-animated mr-1">
            Syncing
        </span>
        <span v-else-if="isDriverOutdated"
            class="badge badge-danger mr-1">
            Out of Sync
        </span>
        <span v-else-if="driverSyncedAt"
            class="badge badge-success mr-1">
            In Sync
        </span> -->
        <span v-if="isVersionLocked" title="`Driver version locked to (id: ${project.driver_version_id})`">
            <svg class="element-icon--lock element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-lock"></use></svg>
        </span>
        <a
            :href="`/projects/${project.id}/edit`"
            :class="{ 'font-weight-bold': project.sync_enabled }"
            :title="project.sync_enabled ? 'Integrated with LXP Portal' : 'Standalone project'"
            target="_blank">
            {{ project.client.name }}: {{ project.name }}
        </a>
    </li>
</template>

<script>
import { localizeDate } from '../helpers/util'

export default {
    props: {
        version: {
            type: Object
        },
        project: {
            type: Object
        }
    },
    data () {
        return {
            isSyncing: false,
            errors: []
        }
    },
    computed: {
        isVersionLocked () {
            return this.project.driver_version_id
        },
        isDriverOutdated () {
            return !this.project.driver_synced_at || this.version.updated_at > this.project.driver_synced_at
        },
        driverSyncedAt () {
            return this.project.driver_synced_at
        }
    },
    methods: {
        localizeDate
    }
}
</script>
